export const readerLanguage = value => ({ ur: 'urdu', ar: 'arabic', en: 'english', hi: 'hindi', de: 'german', es: 'spanish' }[String(value || '').toLowerCase()] || String(value || 'english').toLowerCase());
export const readerLanguageCode = value => ({ urdu: 'ur', arabic: 'ar', english: 'en', hindi: 'hi', german: 'de', spanish: 'es' }[readerLanguage(value)] || 'en');
export function translatedPageText(response, source, destination) {
  const text = response?.data?.data?.translatedContent;
  const valid = response?.status === 200 && typeof text === 'string' && text.trim();
  if (destination === 'en') return valid ? text : source;
  if (!valid) throw new Error('Translation service returned no translated text.');
  if (['ur', 'ar'].includes(destination) && !/[\u0620-\u064a\u066e-\u06d3\u06fa-\u06ff]/u.test(text)) {
    throw new Error('Translation service returned text that is not in the requested language.');
  }
  if (text.replace(/\s+/g, ' ').trim() === source.replace(/\s+/g, ' ').trim()) throw new Error('Translation service returned the original text.');
  return text;
}
